"use strict";

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sparkle = void 0;

function sparkle(element, opts) {
  var _ref = opts || {},
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 0.1 : _ref$padding;

  var bounds = element.getBoundingClientRect();
  var xPadding = bounds.width * padding;
  var yPadding = bounds.height * padding;
  var xBounds = [bounds.x + xPadding, bounds.x + bounds.width - xPadding * 2];
  var yBounds = [bounds.y + yPadding, bounds.y + bounds.height - yPadding * 2];
  var averageSize = Math.max(bounds.x, bounds.y) * 0.035; // 3.5% of the element max dimension

  var numSparkles = 1 + Math.floor(Math.max(bounds.x, bounds.y) * 0.005);
  var cancelFns = [];

  var _loop = function _loop(i) {
    var timeout = setTimeout(function () {
      cancelFns.push(createSparklesLoop(xBounds, yBounds, averageSize, opts));
    }, i * 200);
    cancelFns.push(function () {
      return clearTimeout(timeout);
    });
  };

  for (var i = 0; i < numSparkles; i++) {
    _loop(i);
  }

  return function () {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = cancelFns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var cancel = _step.value;
        cancel();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  };
}

exports.sparkle = sparkle;

function createSparklesLoop(xBounds, yBounds, averageSize, opts) {
  var x = xBounds[0] + Math.random() * (xBounds[1] - xBounds[0]);
  var y = yBounds[0] + Math.random() * (yBounds[1] - yBounds[0]);

  var currentCancel = function currentCancel() {};

  currentCancel = createSparkle(x, y, averageSize, opts, function () {
    currentCancel = createSparklesLoop(xBounds, yBounds, averageSize, opts);
  });
  return function () {
    currentCancel();
  };
}

function createSparkle(x, y, size) {
  var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? '#FFF' : _ref2$color;

  var completeCallback = arguments.length > 4 ? arguments[4] : undefined;
  var particle = document.createElement('particle');
  document.body.appendChild(particle);
  var random = Math.random() * 0.5 + 0.5; // 50% - 150%

  var calculatedSize = size * random;
  particle.style.width = "".concat(calculatedSize, "px");
  particle.style.height = "".concat(calculatedSize, "px");
  particle.style.left = "".concat(x - calculatedSize / 2, "px");
  particle.style.top = "".concat(y - calculatedSize / 2, "px");
  particle.style.borderRadius = '0';
  particle.style.background = color;
  var targetOpacity = 0.95 * random; // More opaque as gets larger

  var rotation = 45 * random;
  var animation = particle.animate([{
    transform: "scale(0) rotate(".concat(rotation, "deg)"),
    opacity: 0
  }, {
    transform: "scale(0) rotate(".concat(rotation, "deg)"),
    opacity: 0,
    offset: 0.4
  }, {
    transform: "scale(1) rotate(".concat(rotation, "deg)"),
    opacity: targetOpacity,
    offset: 0.5
  }, {
    transform: "scale(1) rotate(".concat(rotation, "deg)"),
    opacity: targetOpacity,
    offset: 0.9
  }, {
    transform: "scale(0) rotate(".concat(rotation, "deg)"),
    opacity: 0,
    offset: 1
  }], {
    duration: 2000 + 5000 * random,
    easing: 'ease-in-out'
  });

  animation.onfinish = function () {
    particle.remove();
    completeCallback();
  };

  return function () {
    animation.cancel();
    particle.remove();
  };
}